// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1hV2P","left":"StickyBox_left__6vkZo","right":"StickyBox_right__1qrf1"};